import React from 'react';

// Components
import AppProviders from './AppProviders';
import AppFetcher from './AppFetcher';
import SiftRouter from 'components/Router';
import StaticLoader from 'components/Loader/StaticLoader';

function App() {
  return (
    <AppProviders>
      <AppFetcher>
        {shouldLoadApp => (shouldLoadApp ? <SiftRouter /> : <StaticLoader />)}
      </AppFetcher>
    </AppProviders>
  );
}

export default App;
